import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../Images";
import { Link, useLocation } from "react-router-dom";
import NavFloatingMenu from "./NavFloatingMenu";
import { useDispatch, useSelector } from "react-redux";
import { Remove_User } from "../Redux/actions";
import { GoGlobe } from "react-icons/go";

const AdminNavbar = () => {
  const user = useSelector((state) => state.UserReducer.user);

  const [isNavActive, setIsNavActive] = useState(false);
  const [isUserMenuVisible, setIsUserMenuVisible] = useState(false);
  const [isMobileUser, setIsMobileUser] = useState(false);
  const { pathname } = useLocation();

  const dispatch = useDispatch();

  const logout = () => dispatch(Remove_User());

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    setIsMobileUser(isMobile);
  }, [window.innerWidth]);

  useEffect(() => {
    setIsNavActive(false);
  }, [pathname]);

  const toggleNavbar = () => setIsNavActive(!isNavActive);

  return (
    <Nav>
      <Container $isNavActive={isNavActive}>
        <Link to="/cms" className="z-10">
          <Logo src={Images.Logo} alt="rapid test and trace logo" />
        </Link>
        <MenuIconComp toggleNavbar={toggleNavbar} />
        <NavLinksComp
          isNavActive={isNavActive}
          isUserMenuVisible={isUserMenuVisible}
          setIsUserMenuVisible={setIsUserMenuVisible}
          isMobileUser={isMobileUser}
          logout={logout}
          user={user}
          pathname={pathname}
        />
      </Container>
    </Nav>
  );
};

const NavLinksComp = ({
  isNavActive,
  setIsUserMenuVisible,
  isUserMenuVisible,
  isMobileUser,
  logout,
  user,
  pathname,
}) => {
  const [showBookingSubLinks, setShowBookingSubLinks] = useState(false);
  const [showBookingSubLinks2, setShowBookingSubLinks2] = useState(false);

  return (
    <NavLinksWrapper $isNavActive={isNavActive}>
      {/* <NavLink className=" text-custom-green hover:text-custom-green  hover:border-transparent cursor-auto">
      <GoGlobe className="text-custom-green w-4" />
      <p>{user?.timezone}</p>
    </NavLink> */}
      <Link to="/cms">
        <NavLink $active={pathname === "/cms"}>
          {/* <img src={Images.SearchIcon} alt="search icon" /> */}
          <p>Dashboard</p>
        </NavLink>
      </Link>
      <Link to="/cms/admin/users">
        <NavLink $active={pathname === "/cms/admin/users"}>
          {/* <img src={Images.List} alt="List icon" /> */}
          <p>Users</p>
        </NavLink>
      </Link>
      <Link to="/cms/admin/payments">
        <NavLink $active={pathname === "/cms/admin/payments"}>
          {/* <img src={Images.List} alt="List icon" /> */}
          <p>Payments</p>
        </NavLink>
      </Link>

      <NavLink
        className="relative sm:hover:bg-white sm:px-0"
        onMouseEnter={() => setShowBookingSubLinks(true)}
        onMouseLeave={() => setShowBookingSubLinks(false)}
        onClick={() => setShowBookingSubLinks(!showBookingSubLinks)}
      >
        <NavLink className={showBookingSubLinks ? "bg-gray-100" : ""}>
          Sender Id
        </NavLink>

        {showBookingSubLinks && (
          <SubLinksWrapper2>
            <Link
              to="/cms/admin/sender-id-management"
              className="text-black hover:bg-gray-100 px-4 py-2"
            >
              Manage Sender Ids
            </Link>
            <Link
              to="/cms/admin/sender-id-requests"
              className="text-black hover:bg-gray-100 px-4 py-2"
            >
              New Requests
            </Link>
          </SubLinksWrapper2>
        )}
      </NavLink>
      <NavLink
        onMouseEnter={() => setShowBookingSubLinks2(true)}
        onMouseLeave={() => setShowBookingSubLinks2(false)}
        onClick={() => setShowBookingSubLinks2(!showBookingSubLinks2)}
        className="relative sm:hover:bg-white sm:px-0"
      >
        <NavLink className={showBookingSubLinks2 ? "bg-gray-100" : ""}>
          More
        </NavLink>

        {showBookingSubLinks2 && (
          <SubLinksWrapper>
            <Link
              to="/cms/admin/manage-plans"
              className="text-black hover:bg-gray-100 px-4 py-2 rounded-full"
            >
              Manage plans
            </Link>
            <Link
              to="/cms/admin/sender-id-requests"
              className="text-black hover:bg-gray-100 px-4 py-2 rounded-full"
            >
              New Requests
            </Link>
          </SubLinksWrapper>
        )}
      </NavLink>
      {!isMobileUser && (
        <DesktopMenu
          setIsUserMenuVisible={setIsUserMenuVisible}
          isUserMenuVisible={isUserMenuVisible}
          logout={logout}
          user={user}
        />
      )}
      {isMobileUser && <MobileMenu logout={logout} user={user} />}
    </NavLinksWrapper>
  );
};

const DesktopMenu = ({
  setIsUserMenuVisible,
  isUserMenuVisible,
  logout,
  user,
}) => (
  <NavLink
    $last={true}
    className="md:h-full md:h-16 md:bg-white hover:bg-white "
    onMouseEnter={() => setIsUserMenuVisible(true)}
    onMouseLeave={() => setIsUserMenuVisible(false)}
    onClick={() => setIsUserMenuVisible(!isUserMenuVisible)}
  >
    <UserImage src={user?.userImage || Images.NurseImage} alt="nurse image" />
    <p className="md:hidden">My Profile</p>
    {isUserMenuVisible && (
      <NavFloatingMenu
        setIsUserMenuVisible={setIsUserMenuVisible}
        logout={logout}
      />
    )}
  </NavLink>
);

const MobileMenu = ({ logout, user }) => (
  <>
    <Link to="/my-profile" className="h-full">
      <NavLink title="My Profile">
        <UserImage
          src={user?.userImage || Images.NurseImage}
          alt="nurse image"
        />
        <p>My Profile</p>
      </NavLink>
    </Link>

    <NavLink $last={true} title="logout">
      <Logout onClick={logout}>Logout</Logout>
    </NavLink>
  </>
);

const MenuIconComp = ({ toggleNavbar }) => (
  <MenuIcon onClick={toggleNavbar}>
    <div className="bar one"></div>
    <div className="bar two"></div>
    <div className="bar three"></div>
  </MenuIcon>
);

const Nav = tw.nav`z-40 bg-white w-full border-b navbar fixed top-0 right-0 left-0`;

const MenuIcon = tw.div`cursor-pointer z-10 md:hidden`;

const Container = tw.div` 
Container flex items-center justify-between`;

const Logo = tw.img`w-20 md:w-28 z-10`;

const NavLinksWrapper = tw.ul`
${(p) => (p.$isNavActive ? "translate-y-0" : "-translate-y-full")}
fixed  shadow-md top-0 right-0 left-0 flex flex-col bg-white pt-20 transition duration-200 pb-5  md:relative  md:translate-y-0 md:shadow-none md:flex-row   md:bg-transparent md:p-0   md:items-center w-full md:justify-end md:h-full`;

// const NavLink = tw.li`
// ${(p) => (p.$last ? "" : "border-b")}
// text-sm text-gray-500 hover:text-gray-800 relative hover:bg-gray-100 flex space-x-1.5 items-center cursor-pointer w-full   py-3 nav-links-padding  md:hover:bg-transparent md:p-0 md:bg-tranparent  md:border-transparent  md:border-b-2 hover:border-gray-400  whitespace-nowrap md:w-auto md:h-full `;

const NavLink = tw.li` 
${(p) => (p.$active ? "md:bg-gray-100 text-gray-900" : "")}
text-sm text-gray-500  hover:text-gray-900 relative flex space-x-1.5 items-center cursor-pointer w-full   py-3    px-4 h-9 rounded-full hover:bg-gray-100  whitespace-nowrap md:w-auto md:h-full ml-1 `;

const NavLinkDropDown = tw.li` 
${(p) => (p.$active ? "md:bg-gray-100 text-gray-900" : "")}
text-sm text-gray-500  hover:text-gray-900 relative flex space-x-1.5 items-center cursor-pointer w-full   py-3    px-4 h-9 rounded-full  whitespace-nowrap md:w-auto md:h-full ml-1 `;

const UserImage = tw.img`
w-6 h-6  md:w-8 md:h-8 rounded-full object-cover overflow-hidden bg-gray-100
`;

const UserMenuWrapper = tw.div`
 p-2 relative `;

const Logout = tw.p` 
text-red-500 text-sm cursor-pointer`;

const SubLinksWrapper = tw.div`flex flex-col absolute bottom-0 bg-white p-2 py-1 text-sm  rounded-md border border-gray-200 shadow-md z-10 transform translate-y-full -translate-x-2`;

const SubLinksWrapper2 = tw.div`flex flex-col absolute bottom-0 bg-white p-2 py-3 text-sm  rounded-md border border-gray-200 shadow-md z-10 transform translate-y-full -translate-x-0 `;

export default AdminNavbar;
